import React from 'react'
import InputMask from "react-input-mask";
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import CircularProgress from '@mui/material/CircularProgress';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import { useTheme } from '@emotion/react';



const PhoneInput = (props) => {
    const theme = useTheme()

    const style = {
        helperTextColor: {
            color: theme.palette.success.main,
        },
        checkIconRoot: {
            color: theme.palette.success.main,
        }
    }
    // TODO: this component needs refactoring

    // Extract props (\90) 599 999 99 99
    const { value, onChange, mask, label, disabled, portLogin, fullWidth, required, state, onBlur, center, ...rest } = props


    return (
        <>
            <InputMask
                mask={mask}
                value={value}
                disabled={disabled === true}
                maskChar=' '
                required={required === true}
                onChange={onChange}
                onBlur={onBlur}
            >
                {(inputProps) =>
                    <TextField
                        style={{ marginTop: '5px' }}
                        FormHelperTextProps={{
                            sx: style.helperTextColor
                        }}
                        type='phone'
                        className='mt-0'
                        label={label || ''}
                        // placeholder={props.placeholder || ''} 
                        fullWidth={fullWidth === true}
                        disabled={disabled === true}
                        error={props.error}
                        helperText={props.helperText || ''}
                        {...inputProps}
                        InputProps={{
                            readOnly: portLogin ? true : false,
                            endAdornment: (
                                <InputAdornment position='end'>
                                    {
                                        state === 'loading' &&
                                        <div style={{ paddingRight: '4px' }}>
                                            <CircularProgress
                                                style={{
                                                    width: '16px',
                                                    height: 'unset'
                                                }}
                                            />
                                        </div>
                                    }
                                    {
                                        state === 'success' &&
                                        <CheckIcon sx={style.checkIconRoot} />
                                    }
                                    {
                                        state === 'error' &&
                                        <ErrorIcon color='error' />
                                    }
                                </InputAdornment>
                            ),
                            inputProps: {
                                style: { textAlign: center ? 'center' : '' }
                            }
                        }}
                        {...rest}
                    />}
            </InputMask>
        </>
    )
}

export default PhoneInput